export const PASSWORD_DEFAULTS = { MAX_LENGTH: 64, MIN_LENGTH: 9 };
export const ORIGIN_IS_SSO_EVENT_LINK = "sso-trigger";
export const ORIGIN_IS_SSO_EVENT_LINK_VALUE = "1";

export enum PROVIDERS {
  FACEBOOK = "facebook",
  GOOGLE = "google",
  LINKEDIN = "linkedin",
  MICROSOFT = "microsoft",
}

export const SSO_TOKEN_KEY = "sso-token";
export const SSO_ERROR_KEY = "sso-error";
export const WAIT_FOR_KEYS_IN_LOCAL_STORAGE_INTERVAL = 500;

export const LINKEDIN_POPUP_BROWSING_CONTEXT = "linkedinAuth";

export const MAGIC_LINK_EMAIL_KEY = "magic-link-login-email";

export const SOCIAL_PROVIDERS = [
  PROVIDERS.MICROSOFT,
  PROVIDERS.GOOGLE,
  PROVIDERS.FACEBOOK,
  PROVIDERS.LINKEDIN,
];

export const SOCIAL_PROVIDERS_SSO_PATHS = SOCIAL_PROVIDERS.map(
  (providerName) => `/${providerName}/sso`,
);
